module.exports = __webpack_public_path__ + "static/img/装饰12.6d820ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰12.svg
// module id = YzE9
// module chunks = 2